export default function ButtonGroup(theme) {
    return {
        MuiButtonGroup: {
            defaultProps: {
                disableRipple: true
            }
        }
    };
}
